const getters = {
    token: state => state.user.token, //token
    language: state => state.app.language,//语言
    device: state => state.app.device,//登录设备设备
    domain: state => state.app.domain,//域名
    name: state => state.user.name,//名字
    userInfo: state => state.user.userInfo, //用户信息
    generalData: state => state.user.generalData,//用户通用数据
    isLogin:state=>state.user.isLogin,//是否登录
    constantList:state=>state.user.constantList,//常量

    dictionary:state=>state.user.dictionary,//字典
    dictionaryObj:state=>state.user.dictionaryObj,//字典对象
    showSearch: state => state.app.showSearch,//显示搜索框

    activeNav:state=>state.route.activeNav,//当前激活菜单导航
    activeMenuId:state=>state.route.activeMenuId,//当前激活路由
    menuList:state=>state.route.menuList, //菜单列表

    searchId:state=>state.search.searchId,
    keyWords:state=>state.search.keyWords,
    searchType:state=>state.search.searchType,
}
export default getters
